import "./App.css";
import React from "react";
import ImageView from "./components/ImageView";
// import Water from "./components/WaterMarker"

function App() {
  return <div className="App">
    <h1>WaterMarker</h1>
    <ImageView></ImageView>
  </div>;
}

export default App;
